import type { AuthUser } from '../../model/domain/AuthUser';
import type { UserTO } from '../to/UserTO';

import UserConverter from './UserConverter';

const toDomain = (userTO: UserTO) => {
  return {
    user: UserConverter.toDomain(userTO),
  } as AuthUser;
};

export default {
  toDomain,
};
